import { render, staticRenderFns } from "./page-terminal.vue?vue&type=template&id=4acd0651&scoped=true&"
import script from "./page-terminal.vue?vue&type=script&lang=js&"
export * from "./page-terminal.vue?vue&type=script&lang=js&"
import style0 from "./page-terminal.vue?vue&type=style&index=0&id=4acd0651&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acd0651",
  null
  
)

export default component.exports